import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/Button";
import { NEWSLETTER_URL } from "../utils/newsletter";

export class ContactOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    document.body.style.overflow = "hidden";

    if (!document.querySelector('script[src*="embed.typeform.com"]')) {
      const script = document.createElement("script");
      script.src = "//embed.typeform.com/next/embed.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.body.style.overflow = "";
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.props.toggleContactOverlay();
    }
  }

  render() {
    const { toggleContactOverlay, hours } = this.props;
    const enotecaHours = hours?.enoteca || [];

    return (
      <div className="contact-background" id="contact-background">
        <div
          ref={this.wrapperRef}
          className="contact-wrap"
          id="contact-overlay"
        >
          <div className="contact-content">
            <button
              className="contact-close-icon"
              type="button"
              aria-label="Close contact"
              onClick={toggleContactOverlay}
            />

            <header className="contact-hero">
              <p className="contact-hero__kicker">Auburn Road Vineyards</p>
              <h1 className="huge-text-no-quote contact-hero__title">
                Contact
              </h1>
            </header>

            <div className="contact-content-wrap">
              <section className="contact-section contact-section--form">
                <h2 className="contact-section__title">Get in touch</h2>
                <p className="contact-section__text">
                  Can’t find the answer here? Use the form, or email{" "}
                  <a href="mailto:info@auburnroadvineyards.com">
                    info@auburnroadvineyards.com
                  </a>
                  .
                </p>

                <div className="contact-form-desktop">
                  <div
                    className="contact-typeform"
                    data-tf-widget="t3vHk1tl"
                    data-tf-opacity="0"
                    data-tf-hide-headers
                    data-tf-hide-footer
                  />
                </div>

                <div className="contact-form-mobile">
                  <button
                    className="button button__secondary"
                    type="button"
                    data-tf-popup="t3vHk1tl"
                    data-tf-hide-headers
                    data-tf-hide-footer
                  >
                    Contact Form
                  </button>
                </div>
              </section>

              <aside className="contact-aside">
                <section className="contact-section">
                  <h2 className="contact-section__title">Location & Hours</h2>
                  <a
                    className="contact-address outgoing-link"
                    href="https://www.google.com/maps/search/?api=1&query=117+Sharptown+Auburn+Road,+Pilesgrove,+NJ+08098"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    117 Sharptown Auburn Road, Pilesgrove, NJ 08098
                  </a>
                  {enotecaHours.length > 0 && (
                    <ul className="contact-hours">
                      {enotecaHours.map((x, i) => (
                        <li key={x.key || `${x.days}-${i}`}>
                          <span className="contact-hours__days">{x.days}</span>
                          <span className="contact-hours__time">{x.hours}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </section>

                <section className="contact-section">
                  <h2 className="contact-section__title">F.A.Q.</h2>
                  <p className="contact-section__text">
                    Where to stay nearby, where to find our wine, and more.
                  </p>
                  <Link
                    className="contact-pill-link"
                    to="/faq"
                    onClick={toggleContactOverlay}
                  >
                    Browse the FAQ
                  </Link>
                </section>

                <section className="contact-section">
                  <h2 className="contact-section__title">E-Newsletter</h2>
                  <p className="contact-section__text">
                    No cost, no commitment, just great updates and benefits.
                  </p>
                  <Button
                    type="secondary"
                    small
                    external
                    onClick={() =>
                      (window.location.href = NEWSLETTER_URL)
                    }
                  >
                    Join Now
                  </Button>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactOverlay;
